import { type DropdownMenuGroupProps } from '../jdsdropdownmenu/interface';

export const withLogic =
  (
    Component: React.ComponentType<DropdownMenuGroupProps>
  ): React.FC<DropdownMenuGroupProps> =>
  (props: DropdownMenuGroupProps) => {
    return (
      <Component
        {...{
          ...props,
          _hideTopDivider: !props.label
        }}
      />
    );
  };
export { DropdownMenuGroupProps };
